import { BowlBlock } from '@websolutespa/payload-plugin-bowl';
import { options } from '../../options';
import { withIntegration } from './withIntegration';

export const LlmKbSlack: BowlBlock = withIntegration(options.slug.llmKbSlack, [
  {
    name: 'token',
    type: 'withText',
    required: true,
  },
  {
    name: 'channels',
    type: 'text',
    hasMany: true,
    required: true,
  },
  {
    name: 'numDays',
    type: 'number',
    defaultValue: 7,
  },
  {
    name: 'extension',
    type: 'text',
    hasMany: true,
  },
]);
